import React from 'react';

const CaptchaContext = React.createContext({});

export default CaptchaContext;
